export const CryptoWithDestinationTag = {
  XRP: 'XRP',
  ALGO: 'ALGO',
}
